import { Object3D } from "three";

export abstract class SceneObjectBase {
  abstract get object(): Object3D;
  // TODO: extend this common interface - add update()
  // TODO: don't pass context on construction, but on update
}
